import { FC } from 'react';
import { FormBehavior, observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import CreditSimulationPixKey from './CreditSimulationPixKey';
import {
  type CreditSimulationPixKeyFormValues,
  initialValues,
  validationSchema,
} from './schema';

const CreditSimulationPixKeyContainerContainer: FC = () => {
  const navigate = useNavigate();
  const onSubmit = async (values: CreditSimulationPixKeyFormValues) => {
    navigate(Routes.CREDIT_SIMULATION_PIX_KEY_CONFIRMATION, {
      state: { pixKey: values.CreditSimulationPixKey },
    });
  };
  return (
    <FormBehavior
      validationSchema={validationSchema}
      initialValues={initialValues}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <CreditSimulationPixKey />
    </FormBehavior>
  );
};
export default observer(CreditSimulationPixKeyContainerContainer);
